export default __webpack_public_path__ + "static/media/antelope-10-thumbnail.5f45b0fb.webp";